import {Component, OnInit, ViewChild} from '@angular/core';
import {CatalogService} from '../../services/catalog-service';
import {SharedModule} from '../../components/shared.module';
import {BusStation} from '../../services/models/BusStation';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import {EditBusStationModalComponent} from './edit-bus-station-modal/edit-bus-station-modal.component';
import {MatTooltip} from '@angular/material/tooltip';
import {CityStore} from '../../services/stores/city.store';

@Component({
  selector: 'antm-bus-stations',
  imports: [
    ...SharedModule,
    MatTooltip
  ],
  templateUrl: './bus-stations.component.html',
  styleUrl: './bus-stations.component.scss',
})
export class BusStationsComponent implements OnInit {
  tableColumns: string[] = ['name', 'city', 'edit', 'delete'];
  tableSource = new MatTableDataSource<BusStation>();
  busStations: BusStation[] = [];
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;

  constructor(
    private _catalogService: CatalogService,
    public editDialog: MatDialog,
    public cityStoreService: CityStore
  ) {
  }

  ngOnInit(): void {
    this._catalogService.getAllBusStations().subscribe(data => {
      this.busStations = data;
      this.tableSource = new MatTableDataSource<BusStation>(data);
      this.tableSource.sort = this.sort;
      this.tableSource.paginator = this.paginator;
    });
  }

  editBusStation(id?: string) {
    let station = null;
    if (id) {
      station = this.busStations.find(st => st.id === id);
    }
    const dialogRef = this.editDialog.open(EditBusStationModalComponent, {
      width: '600px',
      data: {busStation: station}
    });

    dialogRef.afterClosed().subscribe((result: BusStation) => {
      if (result != null) {
        if (!this.busStations.find(st => st.id === result.id)) {
          this.busStations = this.busStations.concat(result);
        }	else {
          const index = this.busStations.findIndex(st => st.id === result.id);
          this.busStations[index] = result;
        }
        this.tableSource.data = this.busStations;
      }
    });
  }

  removeBusStations(id: string) {
    // this.busStationService.deleteStation(id).subscribe(() => {
    //   this.busStationList = this.busStationList.filter(station => station.id !== id);
    //   this.tableSource.data = this.busStationList;
    // });
  }
}
